<ng-container *ngIf="isOffcanvas">
  <div class="offcanvas-header py-1 px-1">
    <div class="w-100 d-flex justify-content-between">
      <button type="button" class="btn btn-link w-auto py-2 px-0 text-black" (click)="goBackToSearch()">
        <span class="material-symbols-outlined">chevron_left</span>
        {{ "Back" | translate }}
      </button>
      <a [href]="['./']" routerLinkActive="router-link-active" class="navbar-logo d-flex align-items-center me-2">
        <img src="assets/logo_dt.png" alt="Dental Tour Logo" class="logo-image header-logo-small" />
      </a>
    </div>
  </div>
  <div class="offcanvas-body p-0 pt-3">
    <div ngbAutoFocus></div>
    <ng-template [ngTemplateOutlet]="content"></ng-template>
  </div>
</ng-container>

<div *ngIf="!isOffcanvas">
  <ng-template [ngTemplateOutlet]="content"></ng-template>
</div>

<ng-template #content>
  <app-navbar *ngIf="!isOffcanvas"></app-navbar>
  <div *ngIf="notFound" class="py-5">
    <div class="container-xl container-fluid">
      <div class="card shadow-sm p-4 p-md-5 text-center clinic-not-found">
        <i class="ti ti-building-hospital text-muted mb-3" style="font-size: 48px"></i>
        <h2 class="h4 fw-semibold mb-2">{{ "Clinic not available" | translate }}</h2>
        <p class="text-muted mb-4">
          {{ "The clinic you are looking for does not exist or is no longer available." | translate }}
        </p>
        <div>
          <button type="button" class="btn btn-primary" (click)="goBackToSearch()">
            <i class="ti ti-search me-1"></i>
            {{ "Back to search" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!notFound" [ngClass]="screenSize.isMobile ? 'mb-5' : 'py-4'">
    <div class="container-xl container-fluid" [ngClass]="screenSize.isMobile ? 'px-0' : ''">
      <div class="card shadow-sm top-container" [ngClass]="screenSize.isMobile ? 'px-3 pt-3' : ''">

        <ng-container *ngIf="viewStatus === ViewStatus.LOADING">
          <div class="custom-image-container rounded-3 overflow-hidden position-relative">
            <app-shimmer-loader height="100%" width="100%"></app-shimmer-loader>
          </div>

          <div class="w-max">
            <div class="d-flex justify-content-between align-items-start mb-3">
              <div style="width: 60%;">
                <app-shimmer-loader height="32px" width="100%"></app-shimmer-loader>
              </div>
              <div class="d-none d-md-flex align-items-center gap-2">
                <app-shimmer-loader height="25px" width="80px"></app-shimmer-loader>
              </div>
            </div>

            <div class="d-flex d-md-none gap-2 mb-3">
              <app-shimmer-loader height="24px" width="100px"></app-shimmer-loader>
            </div>

            <div class="d-flex gap-2 mb-3">
              <div style="width: 75%;">
                <app-shimmer-loader height="14px" width="100%"></app-shimmer-loader>
              </div>
            </div>

            <div class="d-flex gap-2 mb-3">
              <div style="width: 40%;">
                <app-shimmer-loader height="14px" width="100%"></app-shimmer-loader>
              </div>
            </div>

            <div class="d-flex gap-2 mb-3">
              <div style="width: 45%;">
                <app-shimmer-loader height="14px" width="100%"></app-shimmer-loader>
              </div>
            </div>

            <div class="top-actions-separator"></div>

            <div class="d-flex gap-2 flex-wrap">
              <app-shimmer-loader height="40px" width="140px" class="d-none d-lg-block"></app-shimmer-loader>

              <div class="d-flex" *ngFor="let i of [1,2,3,4,5]">
                <app-shimmer-loader shape="circle" size="32px"></app-shimmer-loader>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="viewStatus === ViewStatus.READY">
          <div class="custom-image-container rounded-3 overflow-hidden position-relative">
            <app-shimmer-loader *ngIf="!coverImageLoaded" height="100%" width="100%"
              class="position-absolute top-0 start-0">
            </app-shimmer-loader>

            <img [src]="partner?.coverUrl || 'assets/dentalclinic.webp'" class="w-100 h-100 object-fit-cover"
              (load)="onCoverImageLoad()" (error)="onCoverImageError($event)" [class.d-none]="!coverImageLoaded"
              alt="Clinic cover" />
          </div>
          <div class="w-max">
            <div class="d-flex justify-content-between align-items-center w-100 flex-row">
              <div class="d-flex justify-content-between w-100">
                <h2 class="fw-semibold color-primary me-2">
                  {{ partner?.name }}
                </h2>
                <div *ngIf="!screenSize.isMobile" class="d-flex align-items-center">
                  <ng-container *ngIf="showRating">
                    <app-rating-badge [averageRate]="partner?.averageRate" [big]="true"></app-rating-badge>
                  </ng-container>
                  <span class="text-muted" [ngClass]="{ 'ms-2': showRating }" *ngIf="hasReviews">
                    • {{ reviewsLabel }}
                  </span>
                </div>
              </div>
            </div>

            <div>
              <div *ngIf="screenSize.isMobile" class="d-flex align-items-center mb-2">
                <ng-container *ngIf="showRating">
                  <app-rating-badge [averageRate]="partner?.averageRate"></app-rating-badge>
                </ng-container>
                <span class="text-muted small" [ngClass]="{ 'ms-2': showRating }" *ngIf="hasReviews">
                  • {{ reviewsLabel }}
                </span>
              </div>
              <div class="d-flex align-items-start gap-2 text-muted small mb-2">
                <i class="bi bi-geo-alt mt-1"></i>
                <span class="d-flex flex-column">
                  <span>{{ partner?.address }} {{ partner?.homeNumber }} - {{ partner?.city }}, {{ partner?.zipCode }}</span>
                  <span>{{ partner?.district | placeName }}, {{ partner?.region | placeName }}, {{ partner?.country }}</span>
                </span>
              </div>

              <div class="d-flex flex-row align-items-center mb-2 gap-2">
                <i class="bi bi-globe small text-muted" style="font-size: 0.75rem;"></i>
                <span class="text-muted small">{{ "Spoken Languages" | translate }}: &nbsp;</span>
                <div class="flags d-flex gap-1">
                  <img *ngFor="let flag of flagsSrcs" [src]="flag.src" [alt]="flag.name | translate" [title]="flag.name | translate"
                    [attr.aria-label]="flag.name | translate" class="flag-icon" />
                </div>
              </div>

              <div class="text-muted small mb-2" *ngIf="partner?.vat">
                <p class="mb-0">
                  <i class="bi bi-file-earmark me-1 small text-muted"></i>
                  {{ "Vat number" | translate }}:&nbsp;{{ partner?.vat }}
                </p>
              </div>
              <div class="top-actions">
                <div class="top-actions-separator"></div>

                <div class="d-flex align-items-center gap-3 flex-wrap">
                  <button class="btn btn-primary btn-contact d-none d-lg-flex align-items-center gap-2"
                    (click)="openContactModal()">
                    <i class="bi bi-envelope"></i>
                    <span class="small">{{ "Get in touch" | translate }}</span>
                  </button>

                  <div class="d-flex justify-content-start gap-2">
                    <share-button button="facebook" [url]="currentUrl" [title]="title" [description]="description"
                      class="facebook" style="background-color: #e8f0fe !important">
                    </share-button>

                    <share-button button="whatsapp" [url]="currentUrl" [title]="title" [description]="description"
                      class="whatsapp" style="background-color: #e6f4ea !important">
                    </share-button>

                    <share-button button="email" [url]="currentUrl" [title]="title" [description]="description"
                      class="email" style="background-color:#fde8e6 !important">
                    </share-button>

                    <share-button button="sms" [url]="currentUrl" [title]="title" [description]="description"
                      class="sms" style="background-color: #e7f0ff !important">
                    </share-button>
                    <share-button button="copy" [url]="currentUrl" class="copy"
                      style="background-color: #f1f3f4 !important">
                    </share-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="desktop-reviews-layout my-4" *ngIf="!screenSize.isMobile && !screenSize.isTablet">
        <div class="left-section">
          <div class="card shadow-sm">
            <div class="card-body">
              <app-review-summary class="w-100" [viewStatus]="viewStatus" [reviewStats]="reviewStats">
              </app-review-summary>
            </div>
          </div>

          <div class="card shadow-sm">
            <div class="card-body">
              <app-rating-breakdown [reviewStats]="reviewStats" [viewStatus]="viewStatus">
              </app-rating-breakdown>
            </div>
          </div>
        </div>

        <div class="card shadow-sm right-section">
          <app-latest-reviews [reviews]="reviews || []" [partner]="partner" [isOffcanvas]="isOffcanvas"
            [viewStatus]="viewStatus" [reviewStats]="reviewStats">
          </app-latest-reviews>
          <div class="write-review-desktop-footer" *ngIf="viewStatus === ViewStatus.READY">
            <button class="btn btn-outline-primary btn-write-review w-100" (click)="openWriteReviewModal()"
              type="button">
              <i class="bi bi-pencil"></i>
              <span>{{ "Write a review" | translate }}</span>
            </button>
          </div>
        </div>
      </div>

      <ng-container *ngIf="screenSize.isMobile || screenSize.isTablet">
        <div class="d-flex flex-wrap mt-3" [ngClass]="screenSize.isTablet ? '' : 'gap-5'"
          [ngClass]="screenSize.isMobile ? 'px-3' : ''">
          <div class="card shadow-sm w-100">
            <div class="card-body">
              <app-review-summary [viewStatus]="viewStatus" [reviewStats]="reviewStats"></app-review-summary>
            </div>
          </div>
        </div>

        <div class="d-flex flex-wrap mt-3 mb-4" [ngClass]="screenSize.isTablet ? '' : 'gap-5'"
          [ngClass]="screenSize.isMobile ? 'px-3' : ''">
          <div class="card shadow-sm w-100">
            <div class="card-body">
              <app-rating-breakdown class="rating" [reviewStats]="reviewStats" [viewStatus]="viewStatus">
              </app-rating-breakdown>
            </div>
          </div>
        </div>

        <div *ngIf="reviews && reviews.length > 0 && viewStatus == ViewStatus.READY"
          class="w-100 d-flex justify-content-between align-items-center">
          <strong class="m-0 ms-2 ms-lg-0 fs-6">{{ "Reviews from patients" | translate }}:</strong>
          <button *ngIf="!screenSize.isMobile"
            class="btn btn-primary btn-sm d-flex align-items-center justify-content-center p-3 gap-1 small-screen-button"
            type="button" (click)="openWriteReviewModal()">
            <i *ngIf="partner?.topReview !== null || partner?.topReview !== undefined" class="bi bi-pencil"></i>
            <p class="m-0 button-text">{{ "Write review" | translate }}</p>
          </button>
        </div>

        <div class="container-xl container-fluid swiper-container d-flex flex-column gap-7">
          <app-swiper *ngIf="reviews?.length != 0 && viewStatus == ViewStatus.READY" [forceOffcanvas]="isOffcanvas"
            [reviews]="reviews || []" [partner]="partner" [viewStatus]="viewStatus">
          </app-swiper>

          <div class="container-xl container-fluid mb-4 mb-lg-0 mt-0 mt-lg-5"
            *ngIf="reviews?.length == 0 && viewStatus == ViewStatus.READY">
            <div class="empty-state-card card shadow-sm border-0">
              <div class="card-body text-center py-5">
                <div class="empty-state-icon mb-3">
                  <i class="bi bi-star text-muted" style="font-size: 3.5rem;"></i>
                </div>
                <h5 class="fw-semibold mb-2">{{ "No reviews yet" | translate }}</h5>
                <p class="text-muted mb-4">
                  {{ "Be the first to share your experience with this clinic" | translate }}
                </p>
                <button class="btn btn-primary px-4" type="button" (click)="openWriteReviewModal()">
                  <i class="bi bi-pencil-square me-2"></i>
                  {{ "Write the first review" | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="d-block d-lg-none" *ngIf="!notFound">
    <app-sticky-mobile-footer (contactUs)="openContactModal()"
      (writeReview)="openWriteReviewModal()"></app-sticky-mobile-footer>
  </div>
</ng-template>
